import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'eg-form-error',
  templateUrl: './form-error.component.html',
  styleUrls: ['./form-error.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class FormErrorComponent {
  @Input() errorMessage: string;
}
